/**
 * Represents the different data types for fields.
 */
enum FieldType {
    STRING,
}

export default FieldType;
